<template>
    <div class="fu-modal" role="dialog" aria-modal="true" @click.self="$emit('close')">
        <div class="fu-modal__dialog">
            <header class="fu-modal__header">
                <div>
                    <h3 class="fu-modal__title">{{ __('History') }}</h3>
                    <p class="fu-modal__subtitle">{{ (caseData.subject && caseData.subject.name) || '—' }}</p>
                </div>

                <button type="button" class="fu-modal__close" :aria-label="__('close')" @click="$emit('close')">
                    <span class="material-icons-round">close</span>
                </button>
            </header>

            <ul class="fu-modal__list">
                <li v-for="event in caseData.events" :key="event.id" class="fu-history">
                    <span class="fu-history__time">{{ formatDateTime(event.created_at) }}</span>
                    <span class="fu-history__action">{{ eventLabel(event.action, caseData.type) }}</span>
                    <span class="fu-history__meta">{{ event.user || __('system') }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import followUpMixin from './followUpMixin'

export default {
    mixins: [followUpMixin],
    props: {
        caseData: {
            type: Object,
            required: true
        }
    },
    mounted() {
        document.addEventListener('keydown', this.onKeydown)
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.onKeydown)
    },
    methods: {
        onKeydown(event) {
            if (event.key === 'Escape') {
                this.$emit('close')
            }
        }
    }
}
</script>

<style scoped lang="less">
@primary: #5937b7;
@text: #676486;
@heading: #2c2857;
@muted: #b3b1c2;

.fu-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(44, 40, 87, 0.45);

    &__dialog {
        width: 100%;
        max-width: 640px;
        max-height: 80vh;
        display: flex;
        flex-direction: column;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
    }

    &__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        padding: 20px 24px 12px;
        border-bottom: 1px solid #ecebf2;
    }

    &__title {
        margin: 0;
        color: @heading;
        font-size: 16px;
        font-weight: 700;
    }

    &__subtitle {
        margin: 2px 0 0;
        color: @text;
        font-size: 13px;
    }

    &__close {
        display: inline-flex;
        padding: 4px;
        border: 0;
        border-radius: 50%;
        background: none;
        color: @muted;
        cursor: pointer;

        &:hover {
            background: #f3f3f6;
            color: @primary;
        }
    }

    &__list {
        margin: 0;
        padding: 12px 24px 20px;
        list-style: none;
        overflow-y: auto;
    }
}

.fu-history {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 6px 0;
    border-bottom: 1px solid #f3f3f6;
    font-size: 13px;
    color: @text;

    &:last-child {
        border-bottom: 0;
    }

    &__time {
        min-width: 130px;
        color: @muted;
    }

    &__action {
        color: @heading;
        font-weight: 700;
    }

    &__meta {
        color: @muted;
    }
}
</style>
